module.exports = __webpack_public_path__ + "static/media/privacy_policy.986d4c59.pdf";